import { Component } from "@angular/core";

@Component({
  selector: "icon-ajuste-pension-calendario",
  templateUrl: "./ajuste-pension-calendario.svg",
  standalone: true,
})
export class AjustePensionCalendarioComponent {}